export default [
  'MyGarageEducationContentDetails',
  'MyVehicleEducationContentDetails'
]

/* Appears on My Garage page /my-account/vehicles */
/* Appears on My Garage page /my-account/vehicle-details */
